import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import $ from 'jquery';
import './Home.css';
import "owl.carousel/dist/assets/owl.carousel.css"; // Owl Carousel CSS
import "owl.carousel/dist/assets/owl.theme.default.css"; // Owl Carousel Theme CSS

const api_url = process.env.REACT_APP_API_URL;

const Home = () => {
  const [sliders, setSliders] = useState([]);

  // Fetch slider data from the API
  useEffect(() => {
    const fetchSliders = async () => {
      try {
        const response = await axios.get(`${api_url}/home_slider.php`);
        setSliders(response.data);  // Save the fetched data in state
      } catch (error) {
        console.error("Error fetching sliders:", error);
      }
    };

    fetchSliders();
  }, []);  // Empty dependency array to run once when the component mounts

  // Initialize the Owl Carousel once the sliders are loaded
  useEffect(() => {
    if (sliders.length > 0 && window.$) {
      // Initialize Owl Carousel after the sliders data is loaded
      window.$(".header-carousel").owlCarousel({
        autoplay: true,
        smartSpeed: 1500,
        items: 1,
        dots: true,
        loop: true,
        nav: false,
      });
    }
  }, [sliders]);  // Re-run when sliders state changes

  return (
    <>
      <div className="container-fluid p-0 mb-5">
        {/* Only render the carousel if we have data */}
        {sliders.length > 0 && (
          
          <div className="owl-carousel header-carousel position-relative">
            {sliders.map((slider) => (
              
              <div key={slider.sl_id} className="owl-carousel-item position-relative">
               <img
  className="img-fluid"
  src={`https://demo.kvbalumni.org/assets/${slider.sl_img_url}`}
  alt={slider.sl_head_text}
  width="100%"
  height="auto"
/>


                <div
                  className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center"
                  style={{ background: 'rgba(24, 29, 56, .7)' }}
                >
                  <div className="container">
                    <div className="row justify-content-start">
                      <div className="col-sm-10 col-lg-8">
                        <h1 className="display-3 text-white animated slideInDown">
                          {slider.sl_head_text}
                        </h1>
                        <p className="fs-5 text-white mb-4 pb-2">
                          {slider.sl_detail_text}
                        </p>

                        {/* Conditionally render buttons */}
                        {slider.sl_readme_link && slider.sl_readme_link.trim() !== "" && (
                          <Link
                            to={slider.sl_readme_link}
                            className="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft"
                          >
                            Read More
                          </Link>
                        )}

                        {slider.sl_apply_link && slider.sl_apply_link.trim() !== "" && (
                          <Link
                            to={slider.sl_apply_link}
                            className="btn btn-light py-md-3 px-md-5 animated slideInRight"
                          >
                            Join Now
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default Home;
